import * as React from 'react';
import { compose, pure } from 'recompose';
import { useInjectedReducers, useInjectedSagas, } from '@topconagriculture/frontend-utils';
import { RouterOutlet } from '../Utils/RouterOutlet';
const ModuleRoot = ({ reducers, routesConfig, sagas, redirectConfig }) => {
    if (reducers) {
        useInjectedReducers(reducers);
    }
    if (sagas) {
        useInjectedSagas(sagas);
    }
    return React.createElement(RouterOutlet, { routes: routesConfig, redirect: redirectConfig });
};
const ComposedModuleRoot = compose(pure)(ModuleRoot);
ComposedModuleRoot.displayName = 'ModuleRoot';
export default ComposedModuleRoot;
//# sourceMappingURL=ModuleRoot.js.map